import CreateProviderBotContainer from './create-strategy-bot-container';

export default CreateProviderBotContainer;
